import styled from "styled-components";
import PageNotFound from "../../assets/images/404-New.png";

const ErrorPageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-around;
  overflow: hidden;

  > div:nth-child(1) {
    display: flex;
    flex-direction: column;
    margin: 60px auto 0;

    div > p:nth-child(1) {
      font-size: 4rem;
      font-weight: 900;
      margin: 0;
      text-shadow: 2px 0 #000000;
    }

    div > p:nth-child(2) {
      font-size: 1.2rem;
    }
  }

   > div:nth-child(2) {
      width: 50%;
      margin: 0 auto;
      img {
        width:100%;
      }
   }

   @media (max-width: 1024px) {
    > div:nth-child(1) {
      margin-top: 30px;
      div > p:nth-child(1) {
        font-size: 2.5rem;
      }

      div > p:nth-child(2) {
        font-size: 0.7rem;
      }
    }

    @media (max-width: 768px) {
      flex-direction: column-reverse;

      > div:nth-child(1) {
        margin-top: 30px;

        div > p:nth-child(1) {
           font-size: 4rem;
        }

        div > p:nth-child(2) {
          font-size: 1.1rem;
        }
      }

      > div:nth-child(2) {
        overflow:hidden;
        width: 70%;
        img {
         transform: scale(1.2);
         transform-origin: top left;
        }
      }
   }

   @media (max-width: 425px) {
       > div:nth-child(1) {
         width: 100%;
       }

       > div:nth-child(2) {
          width: 100%;
       }
   }
`;

const ErrorPage = () => {
	return (
		<ErrorPageWrapper>
			<div>
				<div>
					<p>
						Credential could
						<br />
						not be found
					</p>
					<p>
						We can't seem to find the page you're looking for.
						<br />
						Try going back to the previous page or return home.
					</p>
				</div>
			</div>
			<div>
				<img src={PageNotFound} alt={"error"} />
			</div>
		</ErrorPageWrapper>
	);
};

export default ErrorPage;
